var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graph-cont-left"},[_c('span',{staticClass:"center"}),_c('div',{ref:"myEchart",staticClass:"graph",staticStyle:{"height":"380px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }